import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import jnu_logo from '../../../assets/jnu_logo.png';
import xaviers_logo from '../../../assets/xaviers_logo.png';
import cghs_logo from '../../../assets/cghs_logo.png';

function ViewMyEdu(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    return (
    <div className="mg-t-20" >
        <div className="card" >
        <div className="card-header">
            <div className="card-header-left">
                <h5>Qualification</h5>
            </div>
            <div className="card-header-right">
                <ul className="row" >                        
                    
                    <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                     
                </ul>                    
            </div>
        </div>         
        <Collapse isOpen={!collapse}> 
            <hr className="mg-l-20" ></hr>
            <div className="card-block">
                <div className="v-align ">
                    <div className="wd-pct-20 mg-r-15 b-r-border">
                        <div >July 1996 - Aug 1998</div>
                        <div>Delhi, India</div>
                    </div>
                    <div className="wd-pct-20 mg-r-15 b-r-border" >
                        <div className="card-list-header">Masters, Economics</div>
                        <div className="card-list-subheader">Jawaharlal Nehru University</div>
                    </div>
                    <div className="wd-pct-15 text-c-success b-r-border">
                        <div >7.3 / 8 CGPA</div>
                        <div> First Class </div>
                    </div>
                    <div >
                    <img alt="" src={jnu_logo} style={{height: '45px'}} className="pd-l-25 c-pointer" />                            
                    </div>
                </div>
                <div className="card-description">
                        Specialization in Econometrics
                    </div> 
                <hr className="mg-r-0" ></hr> 
                <div className="v-align ">
                    <div className="wd-pct-20 mg-r-15 b-r-border">
                        <div >Mar 1993 - Mar 1996</div>
                        <div>Kolkata, India</div>
                    </div>
                    <div className="wd-pct-20 mg-r-15 b-r-border">
                        <div className="card-list-header">Bachelors, Economics</div>
                        <div className="card-list-subheader">St. Xavier's College</div>
                    </div>
                    <div className="wd-pct-15 text-c-success b-r-border">
                        <div >72 Percentage</div>
                        <div> First Class </div>
                    </div>
                    <div >
                    <img alt="" src={xaviers_logo} style={{height: '45px'}} className="pd-l-25 c-pointer" />                            
                    </div>
                </div>
                <div className="card-description">
                    Optionals in Political Science
                </div>                 
                <hr className="mg-r-0" ></hr>
                <div className="v-align ">
                    <div className="wd-pct-20 mg-r-15 b-r-border">
                        <div >Mar 1991 - Mar 1993</div>
                        <div>Kolkata, India</div>
                    </div>
                    <div className="wd-pct-20 mg-r-15 b-r-border">
                        <div className="card-list-header">ISC, Science</div>
                        <div className="card-list-subheader">Calcutta Girls' High School</div>
                    </div>
                    <div className="wd-pct-15 text-c-success b-r-border">
                        <div >91 Percentage</div>
                        <div> First Class </div>
                    </div>
                    <div >
                    <img alt="cghs" src={cghs_logo} style={{height: '45px'}} className="pd-l-25 c-pointer" />                            
                    </div>
                </div>
                <div className="card-description">
                    Additionals in Computer Science
                </div>                  
            </div>
        </Collapse>
    </div>
    </div>
        
    );
  }

export default ViewMyEdu